import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import Nav from "../Components/Nav";
import { auth, db } from "../config";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import axios from "axios";
import Footer from "../Components/Footer";

function Support() {
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        try {
          // Fetch user data from Firestore
          const userDocRef = doc(db, "users", currentUser.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            const userData = userDoc.data();
            setFormData({
              name: userData.name || currentUser.displayName || "",
              email: userData.email || currentUser.email || "",
              message: "",
            });
          } else {
            setMessage("User data not found.");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          setMessage("Error fetching user data.");
        } finally {
          setLoading(false);
        }
      } else {
        setUser(null);
        navigate("/auth/login");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) {
      setMessage("User not authenticated.");
      return;
    }

    if (!formData.message.trim()) {
      setMessage("Message is required.");
      return;
    }

    setSubmitting(true);
    try {

        const emailTemplate = `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: auto; border: 1px solid #e0e0e0; padding: 20px;">
      <!-- Header -->
      <div style="text-align: center; padding-bottom: 20px; border-bottom: 1px solid #ddd;">
         
        <h2 style="margin: 0; color: #333;">${"apexyeild"}</h2>
      </div>

      <!-- Body -->
      <div style="padding: 20px 0; color: #333;">
        ${formData.message}
      </div>

      <!-- Footer -->
      <div style="border-top: 1px solid #ddd; padding-top: 15px; font-size: 12px; color: #777; text-align: center;">
        <p>You're receiving this email from ${"apexyeild"}</p>
        <p>© ${new Date().getFullYear()} ${"apexyeild"}. All rights reserved.</p>
      </div>
    </div>
  `;

      // Send email via server endpoint
      await axios.post("https://renderbackend-4t2p.onrender.com/send-mail", {
      email: "support@apexyeild.com",
      subject:"Support Request from APEXYEILD",
      CompanyName:"TRUE LEDGER ASSITS",
      htmlToSend: emailTemplate,
      });

      setMessage("Your message has been sent successfully!");
      setFormData((prev) => ({ ...prev, message: "" }));
    } catch (error) {
      console.error("Error sending message:", error);
      setMessage("Error sending message: " + (error.response?.data?.message || error.message));
    } finally {
      setSubmitting(false);
    }
  };

  // if (loading) {
  //   return <div>Loading...</div>;
  // }

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>APEXYEILD | Support</title>
        <link
          rel="icon"
          href="https://apexyeild.com/auth/storage/app/public/photos/IQAXeGtikmark.png1744508352"
          type="image/png"
        />
      </Helmet>

      <style>
        {`
          .custom-select {
            display: inline-block;
            max-width: 100%;
            height: calc(2.25rem + 2px);
            padding: .375rem 1.75rem .375rem .75rem;
            line-height: 1.5;
            color: #0b57e3;
            vertical-align: middle;
            background: #fff url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right .75rem center;
            background-size: 8px 10px;
            border: 4px solid black;
            border-radius: .25rem;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
          }
          .custom-select:focus {
            border-color: #80bdff;
            outline: 0;
          }
          .custom-select:disabled {
            color: #868e96;
            background-color: #e9ecef;
          }
          .footer-block {
            min-height: 400px;
            padding: 50px 0;
            background: linear-gradient(to right, #212529, #131516), url(../img/project4.jpg);
          }
          .foot-header {
            font-family: "Montserrat", Sans-serif;
            font-weight: 600;
            font-size: 1rem;
            margin-bottom: 25px;
            color: #4A4A4A;
          }
          .foot {
            display: block;
            font-size: small;
            margin-bottom: 8px;
            font-family: "Montserrat", Sans-serif;
            color: #A1A39E !important;
          }
          .foot:hover {
            text-decoration: none !important;
            color: #FE413C !important;
          }
          .foot::before {
            content: "-";
            margin-right: 3px;
            color: #FE413C;
          }
          .footer-credit {
            font-family: "Montserrat", Sans-serif;
            color: #FE413C;
            font-size: small;
          }
          .footer-block .small-image {
            width: 250px;
            height: auto;
          }
          .message {
            margin-top: 15px;
            padding: 10px;
            border-radius: 5px;
          }
          .message.success {
            background-color: #d4edda;
            color: #155724;
          }
          .message.error {
            background-color: #f8d7da;
            color: #721c24;
          }
          .sidebar {
            min-height: 100vh;
          }
          .sidebar .nav-item.active .nav-link {
            background-color: #007bff;
            color: #fff !important;
          }
          .sidebar .nav-link {
            color: #212529;
          }
          .sidebar .nav-link:hover {
            color: #007bff;
          }
        `}
      </style>

      <div className="wrapper">
        <Nav />
        <div className="main-panel bg-light">
          <div className="content bg-light">
            <div className="page-inner">
              <div className="mb-5 row p-md-3">
                <div className="shadow col-12 p-md-2">
                  <div className="col-12 text-center bg-light p-3">
                    <h1 className="title1 text-dark">APEXYEILD Support</h1>
                    <div className="sign-up-row widget-shadow text-dark">
                      <h4 className="text-dark">
                        For inquiries, suggestions, or complaints, contact us at:
                      </h4>
                      <h1 className="mt-3 text-primary">
                        <a href="mailto:support@apexyeild.com">
                          support@apexyeild.com
                        </a>
                      </h1>
                    </div>
                  </div>
                  <div className="pb-5 col-md-8 offset-md-2">
                    <form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <h5 className="text-dark">
                          Name<span className="text-danger">*</span>
                        </h5>
                        <input
                          type="text"
                          name="name"
                          className="form-control text-dark bg-light"
                          value={formData.name}
                          onChange={handleInputChange}
                          placeholder="Enter your name"
                          required
                          aria-label="Name"
                        />
                      </div>
                      <div className="form-group">
                        <h5 className="text-dark">
                          Email<span className="text-danger">*</span>
                        </h5>
                        <input
                          type="email"
                          name="email"
                          className="form-control text-dark bg-light"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder="Enter your email"
                          required
                          aria-label="Email"
                        />
                      </div>
                      <div className="form-group">
                        <h5 className="text-dark">
                          Message<span className="text-danger">*</span>
                        </h5>
                        <textarea
                          name="message"
                          className="form-control text-dark bg-light"
                          rows={5}
                          value={formData.message}
                          onChange={handleInputChange}
                          placeholder="Enter your message"
                          required
                          aria-label="Message"
                        />
                      </div>
                      {message && (
                        <div className={`message ${message.includes("success") ? "success" : "error"}`}>
                          {message}
                        </div>
                      )}
                      <div className="form-group">
                        <button
                          type="submit"
                          className="py-2 btn btn-primary btn-block"
                          disabled={submitting}
                        >
                          {submitting ? "Sending..." : "Send"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
<Footer/>
            <div
              style={{
                position: "fixed",
                left: 0,
                bottom: 0,
                zIndex: 1,
                width: "100%",
              }}
            >
              <div
                style={{
                  width: "100%",
                  backgroundColor: "#FFFFFF",
                  overflow: "hidden",
                  boxSizing: "content-box",
                  textAlign: "right",
                  lineHeight: "14px",
                  fontSize: "12px",
                  fontFeatureSettings: "normal",
                  textSizeAdjust: "100%",
                  padding: "0px",
                  margin: "0px",
                }}
              >
                <div style={{ height: "40px" }}>
                  <iframe
                    src="https://widget.coinlib.io/widget?type=horizontal_v2&theme=light&pref_coin_id=1505&invert_hover="
                    width="100%"
                    height={36}
                    scrolling="auto"
                    marginWidth={0}
                    marginHeight={0}
                    frameBorder={0}
                    border={0}
                    style={{ border: 0, margin: 0, padding: 0 }}
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Support;
